const translation = {
  phone: "+99890-123-12-23",
  Navigation: {
    Phone: "Телефон",
    Email: "Наш email",
    Quote: "Забронируйте",
    Home: "Дом",
    Services: "Услуги",
    Why: "Почему выбирают нас",
    Who: "О нас ",
    Contact: "Связаться с нами",
    QuoteLast: "Забронируйте",
  },
  AboutArea: {
    aboutOurCompany: "О нашей компании",
    aboutOurCompanySubText: `MANINO УСЛУГИ ПО УБОРКЕ И ПЕРЕЕЗДУ`,
    HassleFree: "Удобная уборка и переезд для занятых людей",
    FreeConsultacy: "Бесплатная консультация",
    Mission: "Наша миссия",
    MissionText: `создавать чистую окружающую среду! Мы предоставляем самый надежный и качественный сервис. `,
    MoreInfo: "Забронируйте сейчас",
    Residential: "Больше информации",
    ResidentialText: `Если у вас мало времени на уборку дома,
      Сервисная служба Манино может вам помочь. Вы думали получить
      регулярные услуги по уборке вашего дома? Вы можете быть удивлены
      по преимуществам. Наши доступные индивидуальные планы уборки, которые
      соответствовать вашим потребностям и графику уборки, чтобы вы могли тратить больше времени
      с семьей и друзьями. Подарите своей семье свежесть и
      более здоровая окружающая среда.`,
    General: "Повседневная уборка ",
    Deep: "Глубокая очистка",
    MoveCleaning: "Уборка до и после переезда ",
    CommercialCleaning: "Коммерческая уборка ",
    CommercialCleaningText: `Если вы управляете бизнесом, поддержание чистоты важно для поддержания здоровой рабочей среды, которая приносит пользу сотрудникам и может помочь вашему бизнесу привлечь новых клиентов и заказчиков. Manino делает коммерческую уборку удобной для владельцев бизнеса и менеджеров объектов. Услуги по коммерческой уборке Manino помогают создать более здоровую внутреннюю среду для сотрудников и посетителей.`,
  },
  PopularServices: {
    subtitle: "Наши популярные услуги",
    title: "Наши популярные услуги",
    serviceItemOne: "Услуги по уборке коммерческих",
    serviceItemTwo: "Услуги по уборке жилых помещений",
    serviceItemThere: "Регулярные услуги по уборке",
    serviceItemFour: "Разовая уборка",
    serviceItemFive: "Уборка перед заселением",
    serviceItemSix: "Уборка после переезда ",
    serviceItemOneInfo:
      "Наши профессиональные услуги по уборке коммерческих помещений высвободят у вас время, чтобы сосредоточиться на других важных вещах, например, на ведении бизнеса или организации.",
    serviceItemTwoInfo:
      "Услуги по уборке дома в Манино созданы для того, чтобы сделать вашу жизнь проще, а ваш дом — чище и здоровее для жизни.",
    serviceItemThereInfo:
      "Нам всем нужен сервис, которому мы можем доверять. Эти услуги по уборке еженедельно, раз в две недели или ежемесячно предлагают ряд преимуществ для поддержания качества вашей жизни и увеличения радости от входа в чистый дом!",
    serviceItemFourInfo:
      "Вы можете рассчитывать на уборку дома Manino, которая освежит ваш дом и облегчит его уход. Таким образом, вы сможете тратить меньше времени на уборку и больше времени на то, чтобы наслаждаться любимыми вещами.",
    serviceItemFiveInfo:
      "Лучшее время для уборки в новом доме — пока он пуст. Наши услуги по уборке при заезде удобно к вашим потребностям и бюджету, поэтому вы выбираете то, что вам нужно.",
    serviceItemSixInfo:
      "Оставить свой прежний дом в отличном состоянии будет намного проще с командой Манино. Мы возьмем на себя уборку, пока вы обустраиваете свое новое место так, как хотите.",
  },
  ChoseArea: {
    WhyHireUs: "Почему нанимают нас",
    ExpertHouse: "Экспертной службе по уборке дома можно доверять",
    EveryCustomer: `Каждый клиент
        особенный`,
    EveryCustomerText: `Каждый клиент уникален. Мы относимся к каждому клиенту индивидуально.
         Для Манино нет работы слишком большой или маленькой.`,
    Quality: "Качество",
    QualityText: `Нет ничего лучше, чем прийти домой в только что убранный дом.
        Когда Манино оказывает услугу, люди это замечают. Мы хотим, чтобы вы гордились
        вашего дома и уверены в нашей способности удовлетворить все ваши потребности в уборке.
          квам`,
    satisfaction: "Ваше удовлетворение имеет значение в комиссиях",
    setisfactionText: `Мы гордимся тем, что предоставляем беззаботное обслуживание. Нашим клиентам нравится то, что мы делаем.
        Каждый член нашей команды проходит тщательную проверку и тщательный процесс обучения.
        при приеме на работу и полностью застрахован для вашей защиты.
          квам`,
    BookAppointment: "Записаться на прием онлайн",
    BookAppointmentText: `Наш интерактивный веб-сайт позволяет вам запланировать следующую уборку онлайн.
          квам`,
    Trust: "Доверия",
    TrustText: `Нашим клиентам нравится, что они могут доверить нам настоящую заботу об их доме.
          Когда вы запрашиваете услуги домработницы Manio, вы всегда можете рассчитывать на то, что мы это сделаем.
          поддерживайте открытую линию связи, обращайте пристальное внимание на каждую информацию,
          и продемонстрировать нашу приверженность вашему полному удовлетворению
          квам`,
    WorryFree: "Не беспокойтесь",
    WorryFreeText: `Мы гордимся тем, что предоставляем беззаботное обслуживание. Наши клиенты
          люблю то, что мы делаем. Каждый член нашей команды проходит тщательную
          проверка и тщательный процесс обучения при приеме на работу, а также полностью застрахован для вашей защиты.
          квам`,
  },
  Footer: {
    OurServices: "Наши услуги",
    Carpet: "Очистка ковров",
    Plumbing: "Сантехнические услуги",
    ParkClear: "Уборка парка",
    Residential: "Жилые услуги",
    Copyright: "Copyright ©",
    AllRightsReserved: "All Rights Reserved",
    Apps: "EZ Apps",
  },
  Blogs: {
    SomeRecent: "Некоторые недавние статьи",
    Work: "Работайте вместе, чтобы создать нечто большее",
  },
  CtaArea: {
    Online: "Онлайн-запись",
    Service: "наименование услуги",
    Commercial: "Коммерческая служба",
    Residential: "Жилищное обслуживание",
    Industrial: "Промышленный сервис",
    CommercialLast: "Коммерческая служба",
    ResidentialLast: "Жилищное обслуживание",
    Submit: "Отправить сейчас",
  },
  PricingArea: {
    Affordable: "Наш доступный пакет",
  },
  Special: "Специальный ценовой пакетБез скрытых платежей",
  ProgressArea: {
    OurWork: "Our work Experience",
    FindStandart: "Найдите стандартную уборку с индивидуальным подходом",
    DuisText: `Duis nunc sodales conubia aid laoreet aliquet nostra
      eleifend lacinias prasent hendrerit quisque penatibus Erat. В пульвинаре
      целое число semper Ridiculus lectuse condimentum obor tise verodar capmtaso morin
      proin nibh posuerКачество ремонтаe.`,
    Repair: "Качество ремонта",
    Happy: "Счастливый клиент",
    Support: "Центр поддержки",
  },
  ProgressArea: {
    SomeCompleted: "Некоторые завершенные проекты",
    EveryProject: "Каждый проект индивидуален, каждый клиент особенный",
  },
  ServiceArea: {
    OurPopular: "Наши популярные услуги",
    OurSuccess: "Наш успех Устранение вашего беспорядка",
  },
  Testimonial: {
    CustomerStatement: "Заявление клиента",
    OurClient: "Отзывы наших клиентов",
    Prev: "Предыдущий",
    Next: "Следующий",
  },
  AboutSinglePrice: {
    CarpetCleaning: "Очистка ковров",
    Bathroom: "Уборка ванной комнаты",
    Floor: "Уборка полов",
    Bedroom: "Уборка спальни",
    Get: "Получить услугу",
  },
  AboutSingleTestimonial: {
    Erat: `Erat dapibus interdum consequat eleifend. Porttitor iaculis per lectus ornare dolor pede.
     Metus urna faucibus montes duis conds imentum congue. Accumsan bibendum pharetra a quisque nulla dictumst quam praesent
     pharetra cos aptent sociosqu. Imperdiet mattis sociosqu differ frome aliquam.`,
  },
  AppointmentSingleFeadback: {
    Hymenaeos: `Hymenaeos rhoncus proin aliquam justo sum mauris rutrum nulam semper purus rutru non sociis
        libero varius cumer to duine felis enisa porta ridiculus nisl acequis.`,
  },
  Breadcrumb: {
    Home: "Дом",
  },
  FaqSingleItem: {
    Edite: `Edite per sociosqu felis quam ridiculus laoreet tempus, eleifend faucibus commodo.
        Laoreet mauris congue sodales interdum lobortis proin laoreet quis arcu nostra et nam primis dolor
        sagittis duis laoreet, ultrices habitasse diam quisque in auctor porta metus viverra curae maecenas
        iaculis tempo pulvinar vitae dictum lorem ipsum orci.`,
  },
  HomeHeroSingleSlide: {
    TakeBack: "Верните себе свободное время!",
    Orderyour: "Закажите ",
    moving: "клининговую",
    service: "услугу",
    LearnMore: "Забронируйте сейчас ",
  },
  HomeHeroSingleSlide2: {
    TakeBack: "Верните себе свободное время!",
    Orderyour: "Закажите ",
    moving: "услугу ",
    service: "переезда ",
    LearnMore: "Забронируйте сейчас ",
  },
  HeroSection: {
    subtitle: "Премиальные услуги для вашего дома",
    title: "Уборка, переезд и аутсорсинг без лишних хлопот",
    description:
      "Освободите время: команда Manino возьмёт на себя уборку, переезд и повседневные задачи.",
    primaryCta: "Забронировать",
    secondaryCta: "Смотреть видео",
    cards: {
      cleaning: {
        title: "Уборка",
        description:
          "Регулярная и генеральная уборка квартир, домов и офисов с экологичными средствами.",
        cta: "Заказать уборку",
      },
      moving: {
        title: "Переезд",
        description:
          "Полное сопровождение переезда: упаковка, транспорт и расстановка мебели без стресса.",
        cta: "Спланировать переезд",
      },
      outsource: {
        title: "Аутсорсинг",
        description:
          "Гибкий персонал для ресепшен, клининга и ежедневной поддержки вашей команды.",
        cta: "Заказать помощь",
      },
    },
  },
  HomeServiceItem: {
    Bras: `Bras fringilla conubia odios uira metus torquent commodo quam
        praesent torna pede`,
    GetQuote: "Получить цитату",
  },
  HomeSingleBlog: {
    HomeCleaning: "Уборка дома",
    Continue: "Продолжить чтение",
  },
  HomeSinglePrice: {
    Carpet: "Очистка ковров",
    Bathroom: "Уборка ванной комнаты",
    Floor: "Чистка полов",
    Bedroom: "Уборка спальни",
  },
  HomeSingleProject: {
    Residential: "Жилищное обслуживание",
  },
  HomeSingleTestimonial: {
    EratText: `Erat dapibus interdum consequat eleifend. Porttitor iaculis per lectus ornare dolor pede.
         Metus urna faucibus montes duis conds imentum congue. Accumsan bibendum pharetra a quisque nulla dictumst
          quam praesent pharetra cos aptent sociosqu. Imperdiet mattis sociosqu differ frome aliquam.`,
  },
  HomeThreeHeroSlide: {
    Fast: "Быстрое и эффективное обслуживание",
    Cleaning: `Очистка
        Превосходство
        Гарантировано!`,
    LearnMore: "Узнать больше",
  },
  HomeThreeSIngleAbout: {
    Duis: `Duis congue atend lorem consequat interdum pretium ligula sempe`,
  },
  HomeThreeSIngleAbout: {
    ByJhon: "Джон Кардо",
    Jun: "02 июня - 2021 г.",
    Continue: "Продолжить чтение",
  },
  HomeThreeSingleChoseArea: {
    FacilsisText: `Facilsis veicula hendrerit turp turpis solutat neique dapibus justo rdiculu dapibus no ridiculuy`,
  },
  HomeThreeSingleFeature: {
    Coingue:
      "Coingue aten lorem consqua interdum pretium ligaula a semper mauris easy dictuma",
  },
  HomeTwoCtaSingleItem: {
    Coingue:
      "Coingue atend lorem consequas interdum pretium ligula semper mauris is dictuma",
  },
  HomeTwoHeroSectionSingleSlide: {
    GetProfessional: "Станьте профессионалом",
    CleaningServices: "Клининговые услуги",
    CleanUp: "Очистите и увидите изменения",
  },
  HomeTwoSingleFeature: {
    Duis: "Duis congue atend lorem consequat interdum pretium ligula",
  },
  ServicePageArea: {
    Buscipit: `Buscipit tincidunt duis antino gravidia nam tellusy
        nascetur neque vulpuits aenean is scelerisque ultrces muscle mass and matter order commo`,
    LearnMore: "Learn More",
  },
  ServiceTestimonial: {
    Hymenaeos: `Hymenaeos rhoncus proin aliquam justo sum mauris rutrum nulam semper purus rutru non sociis
        libero varius cumer to duine felis enisa porta ridiculus nisl acequis.`,
  },
  TeamSIngleBlog: {
    Aug: "август",
    Residential: "Residential",
    Fementum: "Fementum pede commodo sceid ушел из жизни",
    Details: "Подробности здесь",
  },
  Sidebar: {
    Home: "Дом",
    Services: "Услуги",
    WhyHire: "Почему выбирают нас",
    WhoWe: "О нас",
    ContactUs: "контакты о нас",
  },
  SingleAppointmentFeature: {
    Coingue:
      "Coingue aten lorem consqua interdum pretium ligaula a semper mauris easy dictuma",
  },
  SpecialSinglePricingPackage: {
    Carpet: "Очистка ковров",
    Bathroom: "Уборка ванной комнаты",
    Floor: "Уборка полов",
    Bedroom: "Уборка спальни",
  },
  Quote: {
    GetYour: "Забронируйте сейчас",
    Form: "Форма",
    select: "Выбрать",
    numberOfRooms: "Количество комнат",
    numberOfRoomsPh: "Введите количество комнат",
    fullName: "Полное имя",
    fullNamePh: "Введите ваше полное имя",
    address: "Адрес",
    addressPh: "Введите ваш адрес",
    phone: "Телефон",
    submit: "Отправить",
    district: {
      label: "Выберите район Ташкента",
      placeholder: "Выберите район Ташкента",
      items: {
        bektemir: "Бектемир",
        chilonzor: "Чиланзар",
        yashnobod: "Яшнабад",
        mirobod: "Миробод",
        mirzoUlugbek: "Мирзо-Улугбек",
        olmazor: "Алмазар",
        sergeli: "Сергели",
        shayxontohur: "Шайхантахур",
        uchtepa: "Учтепа",
        yakkasaroy: "Яккасарай",
        yangihayot: "Янгихаёт",
      },
    },
    InputTitle: {
      firstName: "Имя",
      lastName: "Фамилия",
      email: "Электронная почта",
      next: "Cледующий",
      back: "Назад",
      address: "Адрес",
      state: "Государство",
      city: "Город",
      zipCode: "Почтовый индекс",
      suit: "Квартира/люкс",
    },
    FormTitle: {
      ServicesPosition: "Выберите тип услуги",
      ServicesType: "Выберите тип услуги",
      ServicesPlan: "Выберите тип услуги",
      Premises: "Площадь вашего помещения",
      AdditionalServices: "Дополнительные услуги",
      Time: "Выберите временной интервал подходящий для вас",
      ClientInfo: "О Вас",
      Salary: "Bаш Чистое помещение тариф",
      Location: "Расположение",
      Recomendation:
        "Первая уборка – это всегда глубокая очистка. Скидка 20% применяется начиная со второго посещения, если вы выберете один из наших еженедельных или ежемесячных планов.",
    },
    ServicesPosition: {
      residential: {
        generial: "Повседневная уборка",
        deep: "Генеральная уборка",
        movie: "Уборка до и после переезда",
        postConstruction: "Уборка после строительства",
      },
      commercial: {
        generial: "Повседневная уборка",
        deep: "Генеральная уборка",
        movie: "Уборка до и после переезда",
      },
      postConstruction: {
        residential: "Жилой",
        commercial: "Коммерческий",
      },
      moving: {
        residential: "Жилой ",
        commercial: "Жилой ",
      },
    },
    ServicesType: {
      residential: "Уборка жилых помещений",
      commercial: "Коммерческая уборка",
      moving: "Переезд ",
    },
    ServicesPlan: {
      week2: "2 раза в неделю",
      week1: "2 раз в неделю ",
      month2: "2 раза в месяц",
      month1: "2 раз в месяц",
      cleaningOne: "разовая уборка",
    },
    AdditionalServices: {
      insideFridge: "Внутрь холодильника",
      insideOven: "Внутрь газ плиты",
      interiorWindows: "Очистки внутренние окна",
      dishwashing: "Мытье посуды (час)",
      furniture: "Химчистка мягкой мебели (час)",
      carpet: "Химчистка ковров (час)",
    },
    Premises: {
      insideFridge: "Количество холодильников",
      insideOven: "Количество газовых плит",
      interiorWindows: "Внутренняя поверхность окна",
      dishwashing: "Как долго (в часах)",
      furniture: "Как долго (в часах)",
      carpet: "Как долго (в часах)",
    },
    Salary: {
      subtitle:
        "Не волнуйтесь – вы можете изменить или отменить его в любое время",
      surfaceTitle: "Общая поверхность",
      salaryTitle: "Первая уборка всего",
      salarySubtitle:
        "Если вы подпишетесь на услугу постоянной уборки, то получите скидку 20% на вторую уборку.",
      servicesTitle: "Тип услуги",
      size: "или",
      price: "Размер",
      test: "Площадь",
      time: "Времия",
    },
    endPage: {
      title: "Спасибо, что доверяете нам!",
      subtitle: "Мы рады служить вам!",
      resTitle:
        "Поздравляем, вы активировали свой заказ, с вами скоро свяжутся!",
      btnToHome: "Дом",
      btn: "Отправка",
    },
  },
};

export default translation;
